import { Link } from 'src/navigation';
import { routeForDocumentWithSubsection } from 'lib/routes';
import styles from './link.module.scss';
import { type ReactNode } from 'react';
import {
	type PortableTextMarkComponentProps,
	type PortableTextMarkComponent,
} from '@portabletext/react';

const linkClasses = (style) => {
	if (style === 'primary' || style === 'secondary') {
		return `${style} button ${styles.button}`;
	} else {
		return null;
	}
};
export const ExternalLink: PortableTextMarkComponent = ({
	value,
	children,
}: IExternalLink) => {
	const { blank, href, style } = value;

	if (!href) {
		return null;
	}

	return (
		<Link
			className={linkClasses(style)}
			href={href}
			target={blank ? '_blank' : '_self'}
			rel="noreferrer"
		>
			{children}
		</Link>
	);
};

interface IExternalLink extends PortableTextMarkComponentProps {
	children: ReactNode;
	value: {
		_type: string;
		blank: boolean;
		href: string;
		style?: string;
	};
}

export const InternalLink: PortableTextMarkComponent = ({
	children,
	value,
}: IInternalLink) => {
	const { link, subsection } = value;
	if (!link) {
		const message =
			'Internal Link failed to resolve. The culprit is forgetting ${groqPTResolver} somewhere.';
		process.env.NODE_ENV === 'development'
			? console.error(message)
			: console.warn(message);
		return null;
	}

	const href = routeForDocumentWithSubsection({ ...link, subsection });
	return (
		<Link href={{ pathname: href }} className={linkClasses(link.style)}>
			{children}
		</Link>
	);
};

interface IInternalLink extends PortableTextMarkComponentProps {
	children: ReactNode;
	value: {
		_type: string;
		link: {
			style?: string;
			language?: string;
		};
		subsection?: string;
		language?: string;
	};
}
